import { getActionProps, Action } from './action';
import { getDayProps, Day } from './day';
import { getMappingProps, Mapping } from './mapping';
import { getNoProps, No } from './no';
import { getTextProps, Text } from './text';
import { getInputProps, Input } from './input';
import { getCustomizeProps, Customize } from './customize';
import type { Components, TableProps } from '../types';
import type { ColumnProps } from 'antd/es/table';
import type { ReactElement } from 'react';

export class Column {

  childrenToColumn<T>(props: TableProps<T>): TableProps<T>['columns'] {
    if (props.columns != null) {
      return props.columns as ColumnProps<T>[];
    }

    if (props.children == null) {
      return;
    }

    const children = props.children.
      filter(child => (child.props?.show) ?? !Object.prototype.hasOwnProperty.call(child.props, 'show'));

    return children.map(child => this.getProps((child as JSX.Element).type.displayName, child));
  }

  private getProps<T>(name: Components, child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
    if (name === 'Day') {
      return getDayProps(child);
    }

    if (name === 'Mapping') {
      return getMappingProps(child);
    }

    if (name === 'No') {
      return getNoProps(child);
    }

    if (name === 'Action') {
      return getActionProps(child);
    }

    if (name === 'Text') {
      return getTextProps(child);
    }

    if (name === 'Input') {
      return getInputProps(child);
    }

    if (name === 'Customize') {
      return getCustomizeProps(child);
    }

    throw new Error('Unsupported component type');
  }

}

export { No, Day, Mapping, Text, Action, Input, Customize };
